<script>
/**
 * This component uses a render function to render a provided scoped slot.
 * Basically a way to get around not allowing tempalte roots...
 * Also can be used to declaratively pass props to slot children.
 */
export default {
  props: {
    renderSlot: {
      type: Function,
      default: function(slotProps) {
        return this.$parent.$scopedSlots.default(slotProps);
      }
    },
    slotProps: {
      type: Object,
      default: () => ({})
    }
  },
  render() {
    return this.renderSlot(this.slotProps);
  }
};
</script>
